import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=ff37e08e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=ff37e08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff37e08e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff37e08e')) {
      api.createRecord('ff37e08e', component.options)
    } else {
      api.reload('ff37e08e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=ff37e08e&scoped=true&", function () {
      api.rerender('ff37e08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25zFodfR0dA13/JS/comp/DocBox.vue"
export default component.exports